import React from 'react';
import { KeyRound, ShieldCheck, HeadphonesIcon, ArrowUpRight } from 'lucide-react';

const services = [
  {
    icon: KeyRound,
    title: 'Check-in personalizzato',
    desc: 'Accoglienza dedicata, consegna chiavi e briefing sulla struttura per un soggiorno senza pensieri.'
  },
  {
    icon: ShieldCheck,
    title: 'Gestione professionale',
    desc: 'Manutenzione, pulizie e cura quotidiana affidate a un team esperto in proprietà di pregio.'
  },
  {
    icon: HeadphonesIcon,
    title: 'Assistenza 24/7',
    desc: 'Un referente sempre disponibile durante il soggiorno per ogni necessità o richiesta speciale.'
  }
];

const PropertyManager = () => {
  return (
    <section id="management" className="bg-[#f3ede0] py-24 md:py-32 border-t border-[#e8e0cf]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid md:grid-cols-2 gap-14 lg:gap-24 items-start mb-16 md:mb-20">
          <div>
            <p className="text-[#C87355] text-xs tracking-[0.4em] uppercase mb-5">Property Management</p>
            <h2 className="font-serif text-[#1f1f1f] text-4xl md:text-5xl lg:text-6xl leading-[1.05] mb-8">
              Gestito con cura da<br />
              <span className="italic text-[#3A4A2C]">Private Properties.</span>
            </h2>
            <p className="text-[#4a4a4a] leading-relaxed text-base md:text-lg mb-6">
              Umbria Genius Loci è gestito da <strong className="text-[#3A4A2C] font-medium">Private Properties</strong>, società specializzata nella gestione professionale di proprietà esclusive in Italia.
            </p>
            <p className="text-[#4a4a4a] leading-relaxed text-base md:text-lg mb-10">
              Un servizio di ospitalità curato in ogni dettaglio, che unisce la sensibilità dell&rsquo;accoglienza italiana a standard di qualità e trasparenza tipici delle strutture di alta gamma.
            </p>

            <a
              href="https://privateproperties.it"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 px-7 py-3.5 text-xs tracking-[0.25em] uppercase bg-[#3A4A2C] text-[#faf7f2] hover:bg-[#C87355] transition-colors duration-300 group"
            >
              Visita privateproperties.it
              <ArrowUpRight size={16} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
            </a>
          </div>

          <div className="relative">
            <div className="border border-[#3A4A2C]/20 bg-[#faf7f2] p-8 md:p-10">
              <div className="flex items-center gap-4 mb-6 pb-6 border-b border-[#e8e0cf]">
                <div className="w-14 h-14 rounded-full border border-[#3A4A2C] flex items-center justify-center bg-[#3A4A2C]">
                  <span className="font-serif italic text-[#e8c98a] text-2xl leading-none">Pp</span>
                </div>
                <div>
                  <div className="text-[10px] tracking-[0.3em] uppercase text-[#8a7a5c] mb-1">Property Manager</div>
                  <div className="font-serif text-xl text-[#1f1f1f]">Private Properties</div>
                </div>
              </div>

              <dl className="space-y-4 text-sm">
                <div className="flex items-baseline justify-between gap-4 border-b border-dashed border-[#e8e0cf] pb-3">
                  <dt className="text-[10px] tracking-[0.3em] uppercase text-[#8a7a5c]">Website</dt>
                  <dd>
                    <a href="https://privateproperties.it" target="_blank" rel="noopener noreferrer" className="text-[#3A4A2C] hover:text-[#C87355] transition-colors">
                      privateproperties.it
                    </a>
                  </dd>
                </div>
                <div className="flex items-baseline justify-between gap-4 border-b border-dashed border-[#e8e0cf] pb-3">
                  <dt className="text-[10px] tracking-[0.3em] uppercase text-[#8a7a5c]">Email</dt>
                  <dd>
                    <a href="mailto:info@privateproperties.it" className="text-[#1f1f1f] hover:text-[#3A4A2C] transition-colors">
                      info@privateproperties.it
                    </a>
                  </dd>
                </div>
                <div className="flex items-baseline justify-between gap-4">
                  <dt className="text-[10px] tracking-[0.3em] uppercase text-[#8a7a5c]">Area di gestione</dt>
                  <dd className="text-[#1f1f1f] text-right">Proprietà di pregio &middot; Italia</dd>
                </div>
              </dl>
            </div>

            <div className="absolute -bottom-4 -right-4 w-24 h-24 border border-[#3A4A2C]/20 hidden md:block -z-0"></div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-10 pt-12 border-t border-[#e8e0cf]">
          {services.map((s) => {
            const Icon = s.icon;
            return (
              <div key={s.title} className="group">
                <div className="w-12 h-12 rounded-full border border-[#3A4A2C]/25 flex items-center justify-center mb-5 group-hover:bg-[#3A4A2C] group-hover:border-[#3A4A2C] transition-all duration-500">
                  <Icon className="text-[#3A4A2C] group-hover:text-[#faf7f2] transition-colors" size={20} />
                </div>
                <h4 className="font-serif text-[#1f1f1f] text-xl md:text-2xl mb-2">{s.title}</h4>
                <p className="text-[#666] text-sm leading-relaxed">{s.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default PropertyManager;
